import React, { useEffect, useContext } from 'react';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';

import Loading from 'components/Loading';
import { confirmUser } from 'store/actions/AuthAction';
import { AuthContext } from 'store/context';

export default function Confirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { AuthDispatch } = useContext(AuthContext);
  const values = queryString.parse(location.search);

  useEffect(() => {
    confirmUser({
      dispatch: AuthDispatch,
      payload: { uid: values.uid || null, token: values.token || null },
      navigate,
    });
  }, []);

  return (
    <>
      <Loading />
    </>
  );
}
